import { MdTypography } from '@antiqua-dls/vue-components'

export default {
  name: 'InventoryHubInfoFooter',
  components: {
    MdTypography
  }
}